"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StringUtils = require("./StringUtils");
var sep = "/";
exports.sep = sep;
var extDelim = ".";
var currentDir = ".";
var parentDir = "..";
var sepCharCode = sep.charCodeAt(0);
var startsWithSeparator = function (path) {
    return path && path.length > 0 && path.charCodeAt(0) === sepCharCode;
};
var isAbsolute = function (path) {
    return startsWithSeparator(path);
};
exports.isAbsolute = isAbsolute;
var endsWithSeparator = function (path) {
    return path && path.length > 0 && path.charCodeAt(path.length - 1) === sepCharCode;
};
var basename = function (path, ext) {
    if (path) {
        var lastSepIdx = path.lastIndexOf(sep);
        var bn = lastSepIdx >= 0 ? path.substring(lastSepIdx + sep.length) : path;
        return ext && StringUtils.endsWith(bn, ext) ? bn.substring(0, bn.length - ext.length) : bn;
    }
};
exports.basename = basename;
var parent = function (path) {
    if (path) {
        var lastSepIdx = path.lastIndexOf(sep);
        if (lastSepIdx > 0) {
            return path.substring(0, lastSepIdx);
        }
    }
};
exports.parent = parent;
var dirname = function (path) {
    if (path) {
        var lastSepIdx = path.lastIndexOf(sep);
        if (lastSepIdx === 0) {
            return sep;
        }
        if (lastSepIdx > 0) {
            var prefix = path.substring(0, lastSepIdx);
            var suffix = path.substring(lastSepIdx + sep.length);
            return suffix ? prefix : this.dirname(prefix);
        }
        return currentDir;
    }
};
exports.dirname = dirname;
var extname = function (path, noDelim) {
    if (noDelim === void 0) { noDelim = false; }
    if (path) {
        var lastExtIdx = path.lastIndexOf(extDelim);
        if (lastExtIdx >= 0) {
            return path.substring(noDelim ? lastExtIdx + 1 : lastExtIdx);
        }
    }
    return "";
};
exports.extname = extname;
var removeExt = function (path) {
    var lastExtIdx = path.lastIndexOf(extDelim);
    var prefix = path.substring(0, lastExtIdx);
    return prefix.length > 0 ? prefix : path;
};
exports.removeExt = removeExt;
var joinInternal = function (arg, state) {
    if (Array.isArray(arg)) {
        arg.forEach(function (a) {
            joinInternal(a, state);
        });
    }
    else if (arg) {
        var s = String(arg);
        if (state.els.length === 0 && startsWithSeparator(s)) {
            state.startSep = true;
        }
        state.endSep = endsWithSeparator(s);
        var ps = arg.split(sep);
        ps.forEach(function (p) {
            if (p) {
                if (p === parentDir) {
                    if (state.els.length > 0) {
                        state.els.splice(state.els.length - 1, 1);
                    }
                }
                else if (p !== currentDir) {
                    state.els.push(p);
                }
            }
        });
    }
    return state;
};
var join = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var state = { els: [], startSep: false, endSep: false };
    Array.prototype.forEach.call(arguments, function (arg) {
        joinInternal(arg, state);
    }, this);
    if (state.els.length > 0) {
        var r = state.els.join(sep);
        return (state.startSep ? sep : "") + r + (state.endSep ? sep : "");
    }
    return state.startSep || state.endSep ? sep : currentDir;
};
exports.join = join;
var normalize = function (path) {
    if (path) {
        var els = path.split(sep);
        return this.join(els);
    }
};
exports.normalize = normalize;
